import { Paper, styled } from "@mui/material";

export const StyledCard = styled(Paper)(({ theme }) => ({
    width: "100%",
    padding: "1.5rem"
}));